"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Aurelius Fine Jewelry",
  quote: "The precision of the .3dm files from Create CAD is unmatched. Our production workflow has never been smoother.",
  position: "Master Jeweler"
}, {
  author: "Lumina Designs",
  quote: "Their 3D printing quality captures every microscopic detail of my complex organic models. Truly professional.",
  position: "Creative Director"
}];
export default function VocesDelVecindario() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223618" id="client-success" className="bg-background py-24 md:py-32 overflow-hidden" ref={ref}>
      <div className={`container mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="max-w-5xl mx-auto">
          <Carousel opts={{
          loop: true,
          align: "center"
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center justify-center text-center px-12 md:px-24 py-8">
                    <Quote className="size-12 md:size-16 text-secondary/20 mb-8 rotate-180 shrink-0" />
                    
                    <blockquote className="mb-10">
                      <p className="font-default italic text-2xl md:text-4xl lg:text-5xl text-foreground leading-relaxed md:leading-snug tracking-tight">
                        "{testimonial.quote}"
                      </p>
                    </blockquote>
                    
                    <div className="flex flex-col items-center gap-3">
                      <cite className="font-default font-bold text-lg md:text-xl text-primary not-italic uppercase tracking-wider">
                        {testimonial.author}
                      </cite>
                      <Badge variant="outline" className="bg-card/40 backdrop-blur-md border-border/50 text-muted-foreground font-mono uppercase tracking-widest text-[10px] md:text-xs px-3 py-1 rounded-md">
                        Verified Partner
                      </Badge>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block">
              <CarouselPrevious className="bg-card/50 hover:bg-secondary hover:text-secondary-foreground border-border/50 transition-colors rounded-md" />
              <CarouselNext className="bg-card/50 hover:bg-secondary hover:text-secondary-foreground border-border/50 transition-colors rounded-md" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}